import {
  GraphTitleOperation,
  LoadingSpinner,
} from '../../../styles/global.styles';
import { FormattedMessage } from 'react-intl';
import { GraphTitle } from '../../../styles/global.styles';
import NoDataIcon from '../../../assets/images/error.png';
import { NoDataContainer } from './noData.styles';
import { HalfPageModule } from '../../../styles/global.styles';

export const NoDataHalfPage = (props: {
  operation: number;
  title: string;
  subtitleSale: string;
  subtitleRent: string;
  loaded?: boolean;
  showLoading?: boolean;
}) => {
  if (props.showLoading && !props.loaded) {
    return (
      <HalfPageModule>
        <LoadingSpinner />
      </HalfPageModule>
    );
  }

  return (
    <HalfPageModule>
      <GraphTitle>
        <FormattedMessage
          id={props.title}
          values={{
            operation: (
              <GraphTitleOperation
                color={props.operation == 1 ? `#775175` : `#CC7D34`}
              >
                {props.operation == 1 ? (
                  <FormattedMessage id={props.subtitleSale} />
                ) : (
                  <FormattedMessage id={props.subtitleRent} />
                )}
              </GraphTitleOperation>
            ),
          }}
        />
      </GraphTitle>
      <NoDataContainer>
        <img src={NoDataIcon} />
        Not enough data to build the graph.
      </NoDataContainer>
    </HalfPageModule>
  );
};
